import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-person_white",
  "use": "icon-person_white-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-person_white\"><defs><style>#icon-person_white .cls-1{fill:#fff;}#icon-person_white .cls-2{fill:#aaa;}</style></defs><title>person_white</title><circle class=\"cls-1\" cx=\"16\" cy=\"16\" r=\"16\" /><path class=\"cls-2\" d=\"M16,5a5.83,5.83,0,0,1,5.78,5.78,5.78,5.78,0,0,1-11.56,0A5.83,5.83,0,0,1,16,5Z\" /><path class=\"cls-2\" d=\"M6.42,23.09a10.43,10.43,0,0,1,19.16,0A14.06,14.06,0,0,1,16,27,14.69,14.69,0,0,1,6.42,23.09Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/person_white.svg
// module id = 3+yg
// module chunks = 39